import Dispatch from "nexia_mobile/flux_like/dispatch";
import Store, { setValueAtPath } from "nexia_mobile/flux_like/store";
import { clearHistoryAndPush } from "nexia_mobile/history";

Dispatch.on("LOCATION_CHANGE", (location) => {
  setValueAtPath("appState.currentLocation", location);
});

const handleReturnToDashboard = () => {
  clearHistoryAndPush("/app/home");
};

const newPromiseRefreshLocation = (handlerToDashboard) => {
  const devices = Store.appState.currentLocation.get("devices");

  return new Promise((resolve) => {
    Store.appState.currentLocation.fetch({
      success: () => {
        const finishRefresh = _.once(() => {
          resolve();
          if (handlerToDashboard) {
            handlerToDashboard();
          }
        });

        // The response is parsed asynchronously, wait until devices actually update.
        devices.once("update", finishRefresh);
        // but if they never do, still hide the spinner 10 seconds after the fetch finishes
        setTimeout(finishRefresh, 10000);
      },
    });
  });
};

let returnToDashboardPromise = Promise.resolve();

Dispatch.on("REFRESH_LOCATION_AND_RETURN_TO_DASHBOARD", () => {
  if (!Store.appState && !Store.appState.currentLocation) {
    return;
  }

  returnToDashboardPromise = newPromiseRefreshLocation(handleReturnToDashboard);
});

// TODO: Better answer for async actions (probably won't have it until we're using redux)
export function getPendingPromiseForRefreshLocationAndReturnToDashboard() {
  return returnToDashboardPromise;
}

let pendingRefreshLocation = Promise.resolve();

Dispatch.on("REFRESH_LOCATION", () => {
  if (!Store.appState && !Store.appState.currentLocation) {
    return;
  }

  pendingRefreshLocation = newPromiseRefreshLocation();
});

// TODO: Better answer for async actions (probably won't have it until we're using redux)
export function getPendingPromiseForRefreshLocation() {
  return pendingRefreshLocation;
}

Dispatch.on("LOCATION_UNREGISTER_THIRDPARTY", (href) => {
  const location = Store.appState.currentLocation;
  location.unregisterThirdParty(href).then(() => {
    if (location !== Store.appState.currentLocation) {
      return;
    }
    location.fetch();
  });
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/location.js